import React, { FC, useEffect } from 'react'
import Input from '../../layout/Input'
import { DEFAULT_COUNTRY_CODE } from '../../../utils/validations/phone'

type PhoneInputProps = {
  phone: string
  setPhone: (phone: string) => void
}

export const PhoneInput: FC<PhoneInputProps> = ({ phone, setPhone }) => {
  useEffect(() => {
    setPhone(DEFAULT_COUNTRY_CODE)
  }, [])

  return <Input name="phone" type="phone" label="Telefonnummer" value={phone} onChange={setPhone} />
}

export default PhoneInput
